module.exports = __webpack_public_path__ + "img/IMG_2428.f96fb531.jpg";